// extracted by mini-css-extract-plugin
module.exports = {"button":"buttons_button__1aN5K","buttonblock":"buttons_buttonblock__2U4TD","block":"buttons_block__1EyB8"};